import React from 'react';

export const Button = ({ children, color = 'default', size = 'default', className = '', ...props }) => {
  const classNames = className.split(' ');

  classNames.push('a-button');

  if (color !== 'default') {
    classNames.push(`a-button--${color}`);
  }

  if (size !== 'default') {
    classNames.push(`a-button--${size}`);
  }

  return (
    <button {...props} className={classNames.join(' ')}>{children}</button>
  );
};

// 必要に応じて以下のようなラッパーを定義
export const ButtonPrimary = (props) => <Button {...props} color="primary" />;
export const ButtonPrimaryAccent = (props) => <Button {...props} color="primary-accent" />;
export const ButtonSecondary = (props) => <Button {...props} color="secondary" />;
export const ButtonSecondaryAccent = (props) => <Button {...props} color="secondary-accent" />;
export const ButtonInfo = (props) => <Button {...props} color="info" />;
export const ButtonWarning = (props) => <Button {...props} color="warning" />;
export const ButtonError = (props) => <Button {...props} color="error" />;
